import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { type PropsWithChildren } from "react";
import { ConfigProvider } from "./config_provider";
import { DialogStateProvider } from "./dialog_state_provider";
import { SearchQueryProvider } from "./search_query_provider";
import { SearchRoutingProvider } from "./search_routing_provider";
import { WebSocketsProvider } from "./web_sockets_provider";

type AppProvidersProps = PropsWithChildren<{
  apiToken: string;
  rootURL: string;
  shadowRoot: ShadowRoot | null;
  triggerId: string | undefined;
}>;

// Basic Tanstack Query client
const queryClient = new QueryClient();

export default function AppProviders({ children, apiToken, rootURL, shadowRoot, triggerId }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <WebSocketsProvider
        apiToken={apiToken}
        rootURL={rootURL}
      >
        <ConfigProvider
          apiToken={apiToken}
          rootURL={rootURL}
          shadowRoot={shadowRoot}
          triggerId={triggerId}
        >
          <SearchQueryProvider>
            <DialogStateProvider>
              <SearchRoutingProvider>{children}</SearchRoutingProvider>
            </DialogStateProvider>
          </SearchQueryProvider>
        </ConfigProvider>
      </WebSocketsProvider>
    </QueryClientProvider>
  );
}
